import { GET_CHAT_ALL } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CHAT_ALL:
            return action.payload;
        default:
            return state;
    }
}
